var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOverlay)?_c('div',{staticClass:"overlay",on:{"click":function($event){$event.stopPropagation();return _vm.closeUiElements($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }